import React from 'react';
import Modal from 'react-modal';
import Link from 'gatsby-link';
import Main from './components/_Main';
import { ModalConsumer } from '../../components/ModalContext';
import Choices from '../../components/Choices/Choices';
import titleGraphic from './img/floskel-flexibel.svg';
import flexibleGem from '../../components/img/gem-flexibel.svg';
import pageData from '../../data/flexibel';

const currentPageData = pageData.find(page => page.order === 2);

const Modal2 = ({ onRequestClose, value, ...otherProps }) => (
  <Modal
    className="Modal"
    overlayClassName="ModalOverlay"
    isOpen
    onRequestClose={onRequestClose}
    {...otherProps}
  >
    <header className="Modal__header">
      <span className="Modal__header__text">
        <span className="Modal__header__headline">{currentPageData.modal.heading}</span>
        <h2 className="Modal__header__title">{value}</h2>
      </span>
      <img alt="Gem" src={flexibleGem} className="Modal__header__graphic" />
    </header>
    <section className="Modal__body">
      <h3 className="Modal__header__subtitle">{currentPageData.modal.subheading}</h3>
      <p>{currentPageData.modal.body}</p>
      <Link
        onClick={onRequestClose}
        to="/A/"
        type="button"
        className="Modal__footer__button button button--primary button--large mt2"
      >
        {currentPageData.modal.buttonText}
      </Link>
    </section>
  </Modal>
);

const Quiz = () => (
  <ModalConsumer>
    {({ showModal }) => (
      <Choices headline={currentPageData.quizHeading}>
        <Choices.Choice
          handleClick={() =>
            showModal(Modal2, {
              value: currentPageData.quizAnswer1.content,
            })
          }
          label={currentPageData.quizAnswer1.content}
          note={currentPageData.quizAnswer1.note}
        />
        <Choices.Choice
          handleClick={() =>
            showModal(Modal2, {
              value: currentPageData.quizAnswer2.content,
            })
          }
          label={currentPageData.quizAnswer2.content}
          note={currentPageData.quizAnswer2.note}
        />
        <Choices.Choice
          handleClick={() =>
            showModal(Modal2, {
              value: currentPageData.quizAnswer3.content,
            })
          }
          label={currentPageData.quizAnswer3.content}
          note={currentPageData.quizAnswer3.note}
        />
        <Choices.Choice
          handleClick={() =>
            showModal(Modal2, {
              value: currentPageData.quizAnswer4.content,
            })
          }
          label={currentPageData.quizAnswer4.content}
          note={currentPageData.quizAnswer4.note}
        />
      </Choices>
    )}
  </ModalConsumer>
);

const Tutorial = () => (
  <div>
    <div className="SectionHeader">
      <span className="SectionHeader__text">
        <h2 className="SectionHeader__title">{currentPageData.heading}</h2>
        <p className="SectionHeader__lead lead">{currentPageData.subheading}</p>
      </span>
      <img alt="" src={titleGraphic} className="SectionHeader__graphic" />
    </div>
  </div>
);

export default () => (
  <Main currentPageNum={2} tutorial={<Tutorial />} quiz={<Quiz />} hasNav={false} />
);



// WEBPACK FOOTER //
// ./src/pages/flexibel/02.js